import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

const EmptySearch = ({
  search,
  selectedFilters,
}) => {
  const intl = useIntl();

  if (!search && selectedFilters.length === 0) {
    return null;
  }

  return (
    <div
      className={classnames('content-wrapper nothing-found-wrapper')}
    >
      <h3>
        {intl.formatMessage({ defaultMessage: 'No files found' })}
      </h3>
      <p>
        {intl.formatMessage({ defaultMessage: 'We can\'t find any file matches in your workspace.' })}<br />
        {search ? (
          intl.formatMessage({ defaultMessage: 'Check your search terms for typos, adjust your filters, or try a different search.' })
        ) : (
          intl.formatMessage({ defaultMessage: 'Adjust your filters to find your files.' })
        )}
      </p>
      <p>
        {search ? (
          <a href="https://help.stockpress.co/en/articles/5937779-searching-for-files-and-collections" target="_blank" rel="noreferrer">
            {intl.formatMessage({ defaultMessage: 'Learn how to search in Stockpress' })} →
          </a>
        ) : (
          <a href="https://help.stockpress.co/en/articles/5936637-dynamic-filters-for-your-files-and-collections" target="_blank" rel="noreferrer">
            {intl.formatMessage({ defaultMessage: 'Learn how to use filters in Stockpress' })} →
          </a>
        )}
      </p>
    </div>
  );
};

const mapStateToProps = state => ({
  search: state.Search.search,
  selectedFilters: state.Files.selectedFilters,
});

EmptySearch.propTypes = {
  search: PropTypes.string,
  selectedFilters: PropTypes.array.isRequired,
};

EmptySearch.defaultProps = {
  search: null,
};

export default connect(mapStateToProps)(EmptySearch);
